<template>

    <div class="row">
        <div class="col-lg-4">

            <b-form-group id="fieldset-country"
                          label-for="countrySelect"
                          class="form my-1"
                          invalid-feedback="Please select country"
                          :state="$v.country.$dirty ? !$v.country.$error : null">
                <template v-slot:label>
                    Country
                    <b-spinner v-if="getCountryAsyncPending" variant="light" class="mx-2" small label="loadingCountry"></b-spinner>
                    <i v-b-tooltip.hover.v-danger title="Could not connect to service" v-if="invalidHttpStatusCode(getCountryAsyncStatusCode)" class="text-danger text-sm ml-2 fa fa-exclamation-triangle"></i>
                </template>

                <multiselect id="countrySelect"
                             v-model="$v.country.$model"
                             :options="countryOptions"
                             placeholder="Select country"
                             :showNoResults="false"
                             :showLabels="false"
                             :allowEmpty="false"
                             :disabled="countryDisabled"
                             label="name" track-by="abbreviation"></multiselect>
            </b-form-group>
        </div>
        <div class="col-lg-4">
            <b-form-group id="fieldset-manufacturer"
                          label-for="manufactuerSelect"
                          class="form my-1"
                          invalid-feedback="Please select manufacturer"
                          :state="$v.manufacturer.$dirty ? !$v.manufacturer.$error : null">

                <template v-slot:label>
                    Manufacturer
                    <b-spinner v-if="getManuAsyncPending" variant="light" class="mx-2" small label="loadingManufacturer"></b-spinner>
                    <i v-b-tooltip.hover.v-danger title="Could not connect to service" v-if="invalidHttpStatusCode(getManuAsyncStatusCode)" class="text-danger text-sm ml-2 fa fa-exclamation-triangle"></i>
                </template>

                <multiselect id="manufactuerSelect"
                             v-model="$v.manufacturer.$model"
                             :options="manufacturerOptions"
                             placeholder="Select manufacturer"
                             :showNoResults="false"
                             :showLabels="false"
                             :allowEmpty="false"
                             :disabled="manufacturerDisabled"
                             label="name" track-by="id"></multiselect>
            </b-form-group>
        </div>
        <div class="col-lg-4">
            <b-form-group id="fieldset-model"
                          label-for="modelSelect"
                          class="form my-1"
                          invalid-feedback="Please select model"
                          :state="$v.model.$dirty ? !$v.model.$error : null">

                <template v-slot:label>
                    Model
                    <b-spinner v-if="getModelAsyncPending" variant="light" class="mx-2" small label="loadingModel"></b-spinner>
                    <i v-b-tooltip.hover.v-danger title="Could not connect to service" v-if="invalidHttpStatusCode(getModelAsyncStatusCode)" class="text-danger text-sm ml-2 fa fa-exclamation-triangle"></i>
                </template>
                <multiselect id="modelSelect"
                             v-model="$v.model.$model"
                             :options="modelOptions"
                             placeholder="Select Model"
                             :showNoResults="false"
                             :showLabels="false"
                             :allowEmpty="false"
                             :disabled="modelDisabled"
                             label="modelNumber" track-by="id"></multiselect>
            </b-form-group>
        </div>
    </div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { required } from 'vuelidate/lib/validators'

    import { mapState } from 'vuex'    

    export default {
        mixins: [validationMixin],
        name: 'inputs-model-select',
        props: {
            allManufacturers: {
                type: Boolean,
                default: true
            },
            showResults: Boolean,
            filterOptions: {
                type: Object,
                default: null
            }
        },
        methods: {
            async updateCountryList() {
                this.country = null
                this.manufacturer = null
                this.model = null                
                await this.$store.dispatch('getCountryData')
            },
            async updateManufacturersList() {
                this.manufacturer = null
                this.model = null
                var payload = { includeBW: this.allManufacturers }
                
                await this.$store.dispatch('getManufacturerData', payload)

            },
            async updateModelsList() {
                this.model = null
                var payload = { manufacturer: this.manufacturer.id }
                
                await this.$store.dispatch('getModelList', payload)
            },
            validate() {
                this.$v.$touch()
                if (this.$v.$anyError) {
                    return false
                }

                // Form submit logic
                return true
            },
        },
        computed: {
            ...mapState([
                'getCountryAsyncPending',
                'getCountryAsyncData',
                'getCountryAsyncStatusCode',
                'getManuAsyncPending',
                'getManuAsyncData',
                'getManuAsyncStatusCode',
                'getModelAsyncPending',
                'getModelAsyncData',
                'getModelAsyncStatusCode',
            ]),

            countryDisabled() { return (this.getCountryAsyncData == null || this.getCountryAsyncPending) },
            manufacturerDisabled() { return (this.country == null || this.getManuAsyncData == null) || this.getManuAsyncPending },
            modelDisabled() { return (this.manufacturer == null || this.getManuAsyncData == null || this.getModelAsyncData == null || this.getModelAsyncPending) },

        },
        data() {
            return {
                country: null,
                countryOptions: [],

                manufacturer: null,
                manufacturerOptions: [],

                model: null,
                modelOptions: [],
            }
        },
        validations: {
            country: { required },
            manufacturer: { required },
            model: { required },

        },
        mounted() {

            this.updateManufacturersList()
            if (!this.getCountryAsyncData || this.getCountryAsyncData.length < 1) {
                this.updateCountryList()
            }
            else {
                this.countryOptions = this.getCountryAsyncData
            }

        },
        watch: {
            country(newValue) {

                if (newValue) {
                    this.isCountryValid = true
                    if (!this.getManuAsyncData || this.getManuAsyncData.length < 1)
                        this.updateManufacturersList()
                    this.manufacturer = null
                    this.model = null
                    this.$emit('update:showResults', false)
                }

            },
            manufacturer(newValue) {

                if (newValue) {
                    this.isManufacturerValid = true
                    this.updateModelsList()
                    this.$emit('update:showResults', false)
                }

            },
            model(newValue) {
                this.isModelValid = true
                if (newValue) {
                    if (this.country && this.model)
                        this.model.associatedModelCountry = this.country
                    var payload = { country: this.country, manufacturer: this.manufacturer, model: this.model }
                    this.$emit('getInputValues', payload)
                }
            },

            getCountryAsyncData(newValue) {
                if (newValue)
                    this.countryOptions = newValue
            },
            getManuAsyncData(newValue) {
                if (newValue) {
                    if (this.filterOptions && this.filterOptions.enabled) {
                        if (this.filterOptions.showBWOnlyOption == true)
                            this.manufacturerOptions = newValue.filter(m => m.id == 'BRADFORDWHITE')
                        else if (this.filterOptions.showBWOnlyOption == false)
                            this.manufacturerOptions = newValue.filter(m => m.id != 'BRADFORDWHITE')
                        else
                            this.manufacturerOptions = newValue
                    }
                    else
                        this.manufacturerOptions = newValue
                }

            },
            getModelAsyncData(newValue) {
                if (newValue)
                    this.modelOptions = newValue

            },
        }
    }
</script>
